export default __webpack_public_path__ + "static/media/berraksu6.66c100a1.jpg";